import { makeStyles } from '@mui/styles';

export const usePurchaseOrderGeneralTabStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
}));
